import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Loading from "@irati/ui/src/Loading"
import {TextButton} from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"

import {getAvatars} from "../../../../services/avatars"

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-bottom: ${padding.base};
`

const Avatar = styled.img`
  width: 100px;
  height: 100px;
  margin: 5px;
`

class Avatars extends PureComponent {
  static propTypes = {
    onSelect: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      load: getAvatars().then((avatars) => this.setState({avatars})),
      avatars: []
    }
  }

  render() {
    const {onSelect} = this.props
    const {load, avatars} = this.state

    return (
      <Loading load={load}>
        <Container>
          {avatars.map((avatar, i) => (
            <TextButton id="avatarImage" key={i} onClick={() => onSelect(avatar)}>
              <Avatar src={avatar} />
            </TextButton>
          ))}
        </Container>
      </Loading>
    )
  }
}

export default Avatars
